import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteDeliveryTypesAdapter = getAdapter({ idFieldName: 'value' });

const quoteDeliveryTypesSlice = createSlice({
  name: 'quoteDeliveryTypes',
  initialState: quoteDeliveryTypesAdapter.getInitialState(),
  reducers: {
    setQuoteDeliveryTypes: (state, { payload: { quoteDeliveryTypes } }) => {
      quoteDeliveryTypesAdapter.setAll(state, quoteDeliveryTypes);
    },
  },
});

const selectors = quoteDeliveryTypesAdapter.getSelectors(({ quoteDeliveryTypes }) => quoteDeliveryTypes);

export const getQuoteDeliveryTypes = (state) => selectors.selectAll(state);

export const {
  setQuoteDeliveryTypes,
} = quoteDeliveryTypesSlice.actions;

export default quoteDeliveryTypesSlice.reducer;
